import "core-js/modules/es.array.push.js";
import { resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, vShow as _vShow, createBlock as _createBlock } from "vue";
import _imports_0 from '@/assets/img/lucky-spin/close.png';
import _imports_1 from '@/assets/img/lucky-spin/avatar.png';
import _imports_2 from '@/assets/img/lucky-spin/help.png';
import _imports_3 from '@/assets/img/lucky-spin/record.png';
import _imports_4 from '@/assets/img/lucky-spin/pointer.png';
const _hoisted_1 = {
  class: "lucky-spin-popup"
};
const _hoisted_2 = {
  class: "popup-main"
};
const _hoisted_3 = {
  class: "popup-header"
};
const _hoisted_4 = {
  class: "popup-content"
};
const _hoisted_5 = {
  class: "popup-content-left"
};
const _hoisted_6 = {
  class: "expires-text"
};
const _hoisted_7 = {
  class: "highlight"
};
const _hoisted_8 = {
  class: "highlight"
};
const _hoisted_9 = {
  class: "highlight"
};
const _hoisted_10 = {
  class: "highlight"
};
const _hoisted_11 = {
  class: "activity-info-border"
};
const _hoisted_12 = {
  class: "activity-info-wrap"
};
const _hoisted_13 = {
  class: "flex justify-between align-start"
};
const _hoisted_14 = {
  class: "total-bonus-wrap"
};
const _hoisted_15 = {
  class: "total-bonus-label"
};
const _hoisted_16 = {
  class: "total-bonus-value"
};
const _hoisted_17 = {
  class: "current-bonus-value"
};
const _hoisted_18 = {
  class: "process-wrap"
};
const _hoisted_19 = {
  key: 1,
  class: "tip-wrap"
};
const _hoisted_20 = {
  class: "highlight"
};
const _hoisted_21 = {
  class: "lucky-player-label"
};
const _hoisted_22 = ["src"];
const _hoisted_23 = {
  key: 1,
  class: "lucky-player-avatar",
  src: _imports_1
};
const _hoisted_24 = {
  class: "lucky-player-name"
};
const _hoisted_25 = {
  class: "lucky-player-bonus"
};
const _hoisted_26 = {
  class: "popup-content-right"
};
const _hoisted_27 = {
  class: "lucky-wheel-bg"
};
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", {
  class: "border-wrap"
}, null, -1);
const _hoisted_29 = [_hoisted_28];
const _hoisted_30 = {
  class: "prize-value"
};
const _hoisted_31 = {
  class: "spin-btn-text"
};
const _hoisted_32 = {
  class: "spin-btn-text align-right"
};
const _hoisted_33 = /*#__PURE__*/_createElementVNode("img", {
  class: "wheel-pointer",
  src: _imports_4
}, null, -1);
const _hoisted_34 = {
  class: "notic-spin-tip"
};
const _hoisted_35 = {
  class: "highlight"
};
const _hoisted_36 = {
  class: "notice-text"
};
const _hoisted_37 = {
  key: 0,
  class: "clover-wrap"
};
const _hoisted_38 = {
  class: "clover-detail-wrap"
};
const _hoisted_39 = {
  class: "colver-text"
};
const _hoisted_40 = {
  class: "clover-tips"
};
import { ref, computed, onMounted, onUnmounted } from 'vue';
import vueSeamlessScroll from "vue-seamless-scroll/src";
import { useWindowSize } from '@vant/use';
import { useAudio } from "@/hooks";
import { useAccountStore, useReddotStore } from '@/store';
import FirstAnimation from './FirstAnimation';
import Record from './Record';
import Reward from './Reward';
import Invite from './Invite';
import Rule from './Rule';
import { queryInviteActivity, spinInviteBonus } from '@/api';
const CIRCLE_ANGLE = 360;
const BIGSIZE = 18;
export default {
  __name: 'index',
  emits: ['onClose'],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    const {
      playAudio
    } = useAudio();
    const {
      width,
      height
    } = useWindowSize();
    const accountStore = useAccountStore();
    const redDotStore = useReddotStore();
    const showFirstAnimation = ref(null);
    const prizeList = ref([]);
    const rollStyle = ref('');
    const inviteRecord = ref({});
    const luckyPlayerList = ref([]);
    const showReward = ref(false);
    const spinReward = ref({});
    const countdown = ref(0);
    const coldDownInterval = ref(null);
    const showRecord = ref(false);
    const showInvite = ref(false);
    const showRule = ref(false);
    const ruleText = ref('');
    const expireObj = computed(() => {
      let expireTime = countdown.value;
      let day = Math.floor(expireTime / (60 * 60 * 24));
      let hour = Math.floor(expireTime % (60 * 60 * 24) / (60 * 60));
      let minute = Math.floor(expireTime % (60 * 60) / 60);
      let second = Math.floor(expireTime % 60);
      return {
        day: fillZero(day),
        hour: fillZero(hour),
        minute: fillZero(minute),
        second: fillZero(second)
      };
    });
    let angleList = [];
    let isRotating = false;
    let rotateAngle = 0;
    let prizeIndex;
    onMounted(() => {
      fetchInviteActivity(true);
    });
    onUnmounted(() => {
      if (coldDownInterval.value) {
        clearInterval(coldDownInterval.value);
      }
    });
    const fetchInviteActivity = needUpdatePrizeList => {
      queryInviteActivity().then(res => {
        const {
          inviteRecordVO,
          playerWithdrawals,
          luckyWheelRewardVOList,
          showAnimation,
          rule
        } = res.data || [];
        inviteRecord.value = inviteRecordVO || {};
        luckyPlayerList.value = playerWithdrawals || [];
        redDotStore.set('inviteFriendToEarnNum', inviteRecord.value.spins);
        if (needUpdatePrizeList || prizeList.value.length == 0) {
          // showFirstAnimation.value = showAnimation || false;
          showFirstAnimation.value = false;
          ruleText.value = rule;
          prizeList.value = formatPrizeList(luckyWheelRewardVOList || []);
          rollStyle.value = '';
          rotateAngle = 0;
          countdown.value = inviteRecord.value.countdown;
          coldDown();
        }
      });
    };
    const coldDown = () => {
      if (coldDownInterval.value) {
        clearInterval(coldDownInterval.value);
      }
      coldDownInterval.value = setInterval(() => {
        countdown.value = countdown.value - 1;
        if (countdown.value === 0) {
          clearInterval(coldDownInterval.value);
          fetchInviteActivity(true);
        }
      }, 1000);
    };
    const formatPrizeList = list => {
      const l = list.length;
      // 计算单个奖项所占的角度
      const average = CIRCLE_ANGLE / l; //60
      const half = average / 2; //30			  
      const rightBig = l == 2 ? '50' : '0';
      const heightBig = l <= 3 ? '100' : '50';
      const topBig = l == 3 ? '-50' : '0';
      const skewMain = l <= 2 ? 0 : -(l - 4) * 90 / l;
      // 循环计算给每个奖项添加style属性
      list.forEach((item, i) => {
        // 每个奖项旋转的位置为 当前 i * 平均值 + 平均值 / 2
        const angle = -(i * average + half);
        const bigAge = l > 2 ? i * 360 / l : '0';
        // 增加 style 这个是给每一个奖项增加的样式
        item.style = `-webkit-transform: rotate(${-angle}deg);
      transform: rotate(${-angle}deg);
      width:${100 / l * 2}%;  
      margin-left: -${100 / l}%;
      font-size:${BIGSIZE - l}px;`;
        //这是给每一个转盘背景新增的样式
        item.style2 = `-webkit-transform: rotate(${bigAge}deg);
      transform: rotate(${bigAge}deg) skewY(${skewMain}deg);
      right:${rightBig * i}%;
      height:${heightBig}%;
      top:${topBig}%;
      width:${l == 1 ? 100 : 50}%;`;
        // 记录每个奖项的角度范围
        angleList.push(angle);
      });
      return list;
    };

    //抽奖
    const doSpin = () => {
      if (isRotating) {
        return false;
      }
      if (!inviteRecord.value.spins) {
        showInvite.value = true;
        return false;
      }
      spinInviteBonus().then(res => {
        const {
          inviteSpinsRewardsVO
        } = res.data || {};
        spinReward.value = inviteSpinsRewardsVO || {};
        prizeList.value.some((item, index) => {
          if (item.id == inviteSpinsRewardsVO.id) {
            prizeIndex = index;
            return true;
          }
        });
        rotating();
      });
    };
    //转盘转动角度
    const rotating = () => {
      isRotating = true;
      const config = {
        duration: 5000,
        circle: 8,
        mode: "ease-in-out"
      };
      // 计算角度      初始角度 + 多旋转的圈数 * 360 + 奖项的角度
      const angle = rotateAngle + config.circle * CIRCLE_ANGLE + angleList[prizeIndex] - rotateAngle % CIRCLE_ANGLE;
      rotateAngle = angle;
      rollStyle.value = `transform: rotate(${rotateAngle}deg); transition: transform 5000ms ease-in-out;`;
      playAudio('roll');
      // 旋转结束后，允许再次触发
      setTimeout(() => {
        isRotating = false;
        showReward.value = true;
        accountStore.fetchBalance();
        fetchInviteActivity();
      }, config.duration + 500);
    };
    const fillZero = num => {
      return num < 10 ? '0' + num : num;
    };
    return (_ctx, _cache) => {
      const _component_van_image = _resolveComponent("van-image");
      const _component_van_popup = _resolveComponent("van-popup");
      const _directive_audio = _resolveDirective("audio");
      return _openBlock(), _createElementBlock(_Fragment, null, [_withDirectives(_createElementVNode("div", _hoisted_1, [_createVNode(_component_van_popup, {
        show: true,
        class: "full-page",
        "close-on-click-overlay": false,
        "lock-scroll": false
      }, {
        default: _withCtx(() => {
          var _inviteRecord$value, _inviteRecord$value2, _inviteRecord$value3, _inviteRecord$value4, _inviteRecord$value5, _inviteRecord$value6, _inviteRecord$value7, _inviteRecord$value8, _inviteRecord$value9, _inviteRecord$value10;
          return [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_withDirectives(_createElementVNode("img", {
            class: "close-icon",
            src: _imports_0,
            onClick: _cache[0] || (_cache[0] = $event => emit('onClose'))
          }, null, 512), [[_directive_audio, void 0, "close"]])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createTextVNode(_toDisplayString(_ctx.$t('luckyWheel.expires')) + " ", 1), _createElementVNode("span", _hoisted_7, _toDisplayString(expireObj.value.day), 1), _createTextVNode("Days "), _createElementVNode("span", _hoisted_8, _toDisplayString(expireObj.value.hour), 1), _createTextVNode("Hours "), _createElementVNode("span", _hoisted_9, _toDisplayString(expireObj.value.minute), 1), _createTextVNode("Minutes "), _createElementVNode("span", _hoisted_10, _toDisplayString(expireObj.value.second), 1), _createTextVNode("Seconds ")]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('luckyWheel.withdrawalAmount')), 1), _createElementVNode("div", _hoisted_16, "₱" + _toDisplayString((_inviteRecord$value = inviteRecord.value) === null || _inviteRecord$value === void 0 ? void 0 : _inviteRecord$value.bonus), 1)])]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_17, "P" + _toDisplayString((_inviteRecord$value2 = inviteRecord.value) === null || _inviteRecord$value2 === void 0 ? void 0 : _inviteRecord$value2.currentBonus), 1), _createElementVNode("div", _hoisted_18, [(_inviteRecord$value3 = inviteRecord.value) !== null && _inviteRecord$value3 !== void 0 && _inviteRecord$value3.currentBonus ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "process-bar",
            style: _normalizeStyle(`width: ${Math.floor(((_inviteRecord$value4 = inviteRecord.value) === null || _inviteRecord$value4 === void 0 ? void 0 : _inviteRecord$value4.currentBonus) / ((_inviteRecord$value5 = inviteRecord.value) === null || _inviteRecord$value5 === void 0 ? void 0 : _inviteRecord$value5.bonus) * 100)}%`)
          }, null, 4)) : _createCommentVNode("", true), ((_inviteRecord$value6 = inviteRecord.value) === null || _inviteRecord$value6 === void 0 ? void 0 : _inviteRecord$value6.currentBonus) > ((_inviteRecord$value7 = inviteRecord.value) === null || _inviteRecord$value7 === void 0 ? void 0 : _inviteRecord$value7.bonus) / 2 ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_createTextVNode(_toDisplayString(_ctx.$t('luckyWheel.missTip1')) + " ", 1), _createElementVNode("span", _hoisted_20, "₱" + _toDisplayString(_ctx.$filter.outputAmount(((_inviteRecord$value8 = inviteRecord.value) === null || _inviteRecord$value8 === void 0 ? void 0 : _inviteRecord$value8.bonus) - ((_inviteRecord$value9 = inviteRecord.value) === null || _inviteRecord$value9 === void 0 ? void 0 : _inviteRecord$value9.currentBonus), 2)), 1), _createTextVNode(" " + _toDisplayString(_ctx.$t('luckyWheel.missTip2')), 1)])) : _createCommentVNode("", true)])])])]), _createVNode(_unref(vueSeamlessScroll), {
            class: "lucky-player-list",
            data: luckyPlayerList.value,
            "class-option": {
              singleHeight: Math.round(42.4 / 430 * _unref(height))
            }
          }, {
            default: _withCtx(() => [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(luckyPlayerList.value, (item, index) => {
              return _openBlock(), _createElementBlock("li", {
                key: index,
                class: "lucky-player-row flex"
              }, [_createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t('luckyWheel.luckyPlayer')), 1), item.imgUrl ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: "lucky-player-avatar",
                src: item.imgUrl
              }, null, 8, _hoisted_22)) : (_openBlock(), _createElementBlock("img", _hoisted_23)), _createElementVNode("div", _hoisted_24, _toDisplayString(item.username), 1), _createElementVNode("div", _hoisted_25, "₱" + _toDisplayString(item.amount), 1)]);
            }), 128))])]),
            _: 1
          }, 8, ["data", "class-option"])]), _createElementVNode("div", _hoisted_26, [_withDirectives(_createElementVNode("img", {
            class: "help-icon",
            src: _imports_2,
            onClick: _cache[1] || (_cache[1] = $event => showRule.value = true)
          }, null, 512), [[_directive_audio]]), _withDirectives(_createElementVNode("img", {
            class: "record-icon",
            src: _imports_3,
            onClick: _cache[2] || (_cache[2] = $event => showRecord.value = true)
          }, null, 512), [[_directive_audio]]), _createElementVNode("div", _hoisted_27, [_createElementVNode("div", {
            class: "lucky-wheel-bg-main",
            style: _normalizeStyle(rollStyle.value)
          }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(prizeList.value, (item, index) => {
            return _openBlock(), _createElementBlock("div", {
              class: _normalizeClass(`lucky-wheel-sector sector-${index}`),
              style: _normalizeStyle(item.style2)
            }, _hoisted_29, 6);
          }), 256))], 4), _createElementVNode("div", {
            class: "prize-list",
            style: _normalizeStyle(rollStyle.value)
          }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(prizeList.value, (prize, index) => {
            return _openBlock(), _createElementBlock("div", {
              key: prize.id,
              class: "prize-item",
              style: _normalizeStyle(prize.style)
            }, [_createElementVNode("div", _hoisted_30, _toDisplayString(prize.productName), 1), _createVNode(_component_van_image, {
              class: "prize-img",
              src: prize.picture,
              fit: "contain"
            }, null, 8, ["src"])], 4);
          }), 128))], 4), _createElementVNode("div", {
            class: "wheel-spin-btn",
            onClick: doSpin
          }, [_createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$t('luckyWheel.start')), 1), _createElementVNode("div", _hoisted_32, _toDisplayString(inviteRecord.value.spins) + "x", 1)]), _hoisted_33]), _withDirectives((_openBlock(), _createElementBlock("div", {
            class: "notice-wrap",
            onClick: _cache[3] || (_cache[3] = $event => showInvite.value = true)
          }, [_createElementVNode("div", _hoisted_34, [_createElementVNode("span", null, _toDisplayString(_ctx.$t('luckyWheel.noticeSpinTip.tip1').format({
            interval: inviteRecord.value.extraFreeSpinsInterval
          })), 1), _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.$t('luckyWheel.noticeSpinTip.tip2').format({
            spin: inviteRecord.value.extraFreeSpins
          })), 1), _createElementVNode("span", null, _toDisplayString(_ctx.$t('luckyWheel.noticeSpinTip.tip3')), 1)]), _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.$t('luckyWheel.notice')), 1)])), [[_directive_audio]]), (_inviteRecord$value10 = inviteRecord.value) !== null && _inviteRecord$value10 !== void 0 && _inviteRecord$value10.currentClover ? (_openBlock(), _createElementBlock("div", _hoisted_37, [_createElementVNode("div", _hoisted_38, [_createElementVNode("div", _hoisted_39, _toDisplayString(inviteRecord.value.currentClover) + " " + _toDisplayString(_ctx.$t('luckyWheel.outOf')) + " " + _toDisplayString(inviteRecord.value.targetClover), 1)]), _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.$t('luckyWheel.cloverTips').format({
            count: inviteRecord.value.targetClover
          })), 1)])) : _createCommentVNode("", true)])])])];
        }),
        _: 1
      })], 512), [[_vShow, showFirstAnimation.value != null]]), showFirstAnimation.value ? (_openBlock(), _createBlock(_unref(FirstAnimation), {
        key: 0,
        inviteRecord: inviteRecord.value,
        onOnClose: _cache[4] || (_cache[4] = $event => showFirstAnimation.value = false)
      }, null, 8, ["inviteRecord"])) : _createCommentVNode("", true), showRecord.value ? (_openBlock(), _createBlock(_unref(Record), {
        key: 1,
        onOnClose: _cache[5] || (_cache[5] = $event => showRecord.value = false)
      })) : _createCommentVNode("", true), showReward.value ? (_openBlock(), _createBlock(_unref(Reward), {
        key: 2,
        reward: spinReward.value,
        onOnClose: _cache[6] || (_cache[6] = $event => showReward.value = false)
      }, null, 8, ["reward"])) : _createCommentVNode("", true), showInvite.value ? (_openBlock(), _createBlock(_unref(Invite), {
        key: 3,
        onOnClose: _cache[7] || (_cache[7] = $event => showInvite.value = false)
      })) : _createCommentVNode("", true), showRule.value ? (_openBlock(), _createBlock(_unref(Rule), {
        key: 4,
        rule: ruleText.value,
        onOnClose: _cache[8] || (_cache[8] = $event => showRule.value = false)
      }, null, 8, ["rule"])) : _createCommentVNode("", true)], 64);
    };
  }
};